import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=ed25159a&scoped=true&"
import script from "./HistoryDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=ed25159a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed25159a",
  null
  
)

export default component.exports